// The filter breaks a server rule, so it cannot be applied. `path` points at the broken part.
export class InvalidFilterError extends Error {
  readonly path: string;

  constructor(path: string, reason: string) {
    super(`${path || "filter"} ${reason}`);
    this.name = "InvalidFilterError";
    this.path = path;
  }
}
